import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { concatPath } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { RootPath, ManagerPath, StaffPath } from '../../../../../routes/manager/manager-enums';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { useShiftsStore } from '../../../../../store/use-shifts-store';
import { IdValue } from '../../../../../types/props';

export const useShiftsImport = () => {
  const { t, getLocale } = useLang();
  const [file, setFile] = useState<File>();
  const { isLoading, uploadShifts, confirmUpload } = useShiftsStore();
  const { fetchBranches, place } = useBranchesStore();
  const navigate = useNavigate();

  const handleDrop = async (file: File) => {
    const formData = new FormData();
    formData.append('data', file);
    formData.append('place_id', String(branch?.id));
    uploadShifts(formData).then(() => setFile(file));
  };

  const handleConfirm = () => {
    confirmUpload().then(() => {
      navigate(concatPath([RootPath.Manager, ManagerPath.Staff, StaffPath.Shifts]));
    });
  };

  useEffect(() => {
    fetchBranches({ is_by_company: true, n: 1000, since_id: 0 });
  }, []);

  const [branch, setBranch] = useState<IdValue>();

  const branches = useMemo(
    () => place?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [],
    [place],
  );

  const isDisabledUpload = !file || isLoading || !branch;

  return {
    t,
    isLoading,
    file,
    handleDrop,
    handleConfirm,
    branches,
    branch,
    setBranch,
    isDisabledUpload,
    isDropDisabled: !branch,
  };
};
